import './skeleton-image.scss';

import type { CSSProperties } from 'react';

import { cn } from '../../utils/helpers.ts';

type SkeletonImageProps = {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  style?: CSSProperties;
  className?: string;
};

/**
 * A skeleton placeholder that mimics the blurred placeholder shown by the
 * Image component while an image loads. Use this in skeleton screens where
 * an image will eventually appear, so the visual transition is seamless.
 */
export const SkeletonImage: React.FC<SkeletonImageProps> = ({
  width,
  height,
  borderRadius,
  style,
  className,
}) => (
  <div
    className={cn('SkeletonImage', className)}
    style={{ width, height, borderRadius, ...style }}
  >
    <div className="SkeletonImage__blur" />
  </div>
);
